export function getWeight(state) {
    return state.user && state.user.weight ? state.user.weight : state.averageWeight;
}

export function getMET(state) {
    return (section, difficulty = false) => {
        if (section.kind === 'warm_up' || section.kind === 'cool_down') {
            return state.met[section.kind];
        } else if (difficulty) {
            return state.met[difficulty];
        } else {
            return state.met.fallback;
        }
    }
}

export function trainers(state) {
    return state.trainers
}

export function activeWorkout(state) {
    return state.activeWorkout
}

export function user(state) {
    return state.user
}

export function userFavourites(state) {
    return state.favourites
}

export function searchTerm(state) {
    return state.searchTerm
}

export function staticWorkoutIds(state) {
    return state.staticWorkoutIds
}

export function staticWorkouts(state) { //remove after christmas
    return state.staticWorkouts
}

export function christmasWorkoutIds(state) {
    return state.christmasWorkoutIds
}

export function isMobileNav(state) {
    return state.isMobileNav
}

export function isNotebook(state) {
    return state.isNotebook
}

export function filters(state) {
    return state.filters
}

export function goals(state) {
    return state.goals
}

export function interests(state) {
    return state.interests
}

export function reasons(state) {
    return state.reasons
}